import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnamneseConfiguracaoInserirComponent } from './anamnese-configuracao-inserir.component';
import { AnamneseConfiguracaoInserirRoutingModule } from './anamnese-configuracao-inserir-routing.module';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { DividerModule } from 'primeng/divider';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TooltipModule } from 'primeng/tooltip';




@NgModule({
  declarations: [
    AnamneseConfiguracaoInserirComponent
  ],
  imports: [
    CommonModule,
    AnamneseConfiguracaoInserirRoutingModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    MessagesModule,
    DividerModule,
    InputSwitchModule,
    TooltipModule
  ]
})
export class AnamneseConfiguracaoInserirModule { }
